export const isEditing = (e: KeyboardEvent) =>
  ((e.metaKey || e.ctrlKey) && letterKeys.includes(e.code)) ||
  modifierKeys.includes(e.code);

// Allowed keys when Ctrl or Alt (Meta) keys are pressed
const letterKeys = ['KeyA', 'KeyC', 'KeyX', 'KeyV'];
// Allowed keys during input
const modifierKeys = [
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Home',
  'End',
  'Tab',
  'Escape',
  'Enter',
  'Control',
];
